import { render, staticRenderFns } from "./DefaultTmpl.vue?vue&type=template&id=5cce64e0&scoped=true&"
import script from "./DefaultTmpl.vue?vue&type=script&lang=js&"
export * from "./DefaultTmpl.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTmpl.vue?vue&type=style&index=0&id=5cce64e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce64e0",
  null
  
)

export default component.exports